import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Webinars from "../components/Webinars";
import Team from "../components/Team";
import ApplicationDialog from "../components/ApplicationDialog";
import FloatingContact from "../components/FloatingContact";

const TeamPage = () => {
  const [formOpen, setFormOpen] = useState(false);
  return (
    <div className="min-h-screen" style={{ background: '#FAF8F5' }}>
      <Header onOpenForm={() => setFormOpen(true)} />
      <div className="pt-28 md:pt-36">
        <Team onOpenForm={() => setFormOpen(true)} />
      </div>
      <Webinars />
      <Footer />
      <FloatingContact onOpenForm={() => setFormOpen(true)} />
      <ApplicationDialog open={formOpen} onOpenChange={setFormOpen} />
    </div>
  );
};

export default TeamPage;
